const packageName = "@atlassian/product-search-dialog";
const packageVersion = "13.35.2";
export const BUILD_VERSION = `${packageName}@${packageVersion}`;